import axios, { AxiosResponse } from 'axios';
import api from '../api';

const facebookApi = axios.create({
  baseURL: `${process.env.VUE_APP_FACEBOOK_API}/api`,
  headers: api.defaults.headers,
});

const deleteUser = async (
  payload: Services.LiveSocial.Facebook.DeleteUser,
): Promise<AxiosResponse> => (
  facebookApi.delete(`/user/${payload.userId}`)
);

const getLiveOnFeed = async (
  payload: Services.LiveSocial.Facebook.GetLive,
): Promise<AxiosResponse<Services.LiveSocial.Facebook.Response.GetLive>> => (
  facebookApi.get(`user/${payload.user_id}/live/${payload.live_id}`)
);

const getLiveOnPage = async (
  payload: Services.LiveSocial.Facebook.GetLive,
): Promise<AxiosResponse<Services.LiveSocial.Facebook.Response.GetLive>> => (
  facebookApi.get(`page/${payload.page_id}/${payload.user_id}/live/${payload.live_id}`)
);

const getUser = async (
  userId: string,
): Promise<AxiosResponse<Store.LiveSocial.Facebook.UserData>> => (
  facebookApi.get(`user/${userId}`)
);

const postLiveOnFeed = async (
  payload: Services.LiveSocial.Facebook.PostLive,
): Promise<AxiosResponse<Services.LiveSocial.Facebook.Response.PostLive>> => (
  facebookApi.post(`/user/${payload.user_id}/live`, payload)
);

const postLiveOnPage = async (
  payload: Services.LiveSocial.Facebook.PostLive,
): Promise<AxiosResponse<Services.LiveSocial.Facebook.Response.PostLive>> => (
  facebookApi.post(`/page/${payload.page_id}/${payload.user_id}/live`, payload)
);

const putLiveOnFeed = async (
  payload: Services.LiveSocial.Facebook.PutLive,
): Promise<AxiosResponse> => (
  facebookApi.put(`user/${payload.user_id}/live/${payload.live_id}`, payload)
);

const putLiveOnPage = async (
  payload: Services.LiveSocial.Facebook.PutLive,
): Promise<AxiosResponse> => (
  facebookApi.put(`page/${payload.page_id}/${payload.user_id}/live/${payload.live_id}`, payload)
);

// youtube api target calls
const removeWowzaTarget = async (
  payload: Services.LiveSocial.Facebook.RemoveWowzaTarget,
): Promise<AxiosResponse> => {
  const { application, streamtargetname } = payload;

  return facebookApi.delete(`/stream-target/${application}/${streamtargetname}`);
};

const createWowzaTarget = async (
  payload: Services.LiveSocial.Facebook.CreateWowzaTarget,
): Promise<AxiosResponse> => (
  facebookApi.post('stream-target', payload)
);

const changeWowzaTarget = async (
  payload: Services.LiveSocial.Facebook.ChangeWowzaTarget,
): Promise<AxiosResponse> => {
  const { application, streamtargetname, action } = payload;

  return facebookApi.put(`/stream-target/${application}/${streamtargetname}/${action}`);
};

const facebook = {
  deleteUser,
  getLiveOnFeed,
  getLiveOnPage,
  getUser,
  postLiveOnFeed,
  postLiveOnPage,
  putLiveOnFeed,
  putLiveOnPage,
  removeWowzaTarget,
  createWowzaTarget,
  changeWowzaTarget,
};

export default facebook;
